import AnimatedLink from "@components/animated-link";
import { roundness } from "@provider/dripsy";
import { Text, useSx } from "dripsy";
import * as React from "react";
import type { BaseScreen, ExtractRouteParams } from "react-native-ridge-navigation";

import ChevronRight from "./icons/chevron-right";

function Link<T extends BaseScreen>({
  title,
  to,
  params,
  outline,
}: {
  title: string;
  to: T;
  params: ExtractRouteParams<T["path"]>;
  outline?: boolean;
}) {
  const sx = useSx();
  return (
    <AnimatedLink
      to={to}
      params={params}
      animate={React.useMemo(
        () =>
          ({ hovered, pressed }) => {
            return {
              backgroundColor: hovered || pressed ? "rgba(0,0,0,0.1)" : "rgba(0,0,0,0)",
            };
          },
        []
      )}
      style={sx({
        flexDirection: "row",
        alignItems: "center",
        paddingRight: "$4",
        paddingLeft: "$4",
        paddingTop: "$2",
        paddingBottom: "$2",
        borderRadius: roundness,
        borderWidth: outline ? 2 : 0,
        borderColor: "$primary",
      })}
    >
      <Text
        sx={{
          color: "$primary",
          fontSize: 14,
          fontWeight: "600",
          marginRight: 10,
        }}
      >
        {title}
      </Text>

      <ChevronRight color="$primary" width={8} height={12} />
    </AnimatedLink>
  );
}
export default Link;
